export enum SplashState {
    NONE,
    MAIN,
    POLICY,
    CHANGELOG,
    PREFERENCES,
    NOTIFICATION,
}
